<template>
  <v-dialog v-model="dialog" :width="580" persistent>
    <v-card class="card_container">
      <v-card-title class="headline">
        {{ title }}
      </v-card-title>
      <v-card-text class="card-text">
        {{ message }}
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        
        <v-btn text @click="closeDialog" class="left-btn" v-if="btn1Text"
          >{{ btn1Text }}</v-btn
        >
        <v-btn @click="confirmAction" class="right-btn">{{ btn2Text }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "Dialog",
  props: {
    dialog: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: "Discard Unsaved Changes?",
    },
    message: {
      type: String,
      default:
        "You will lose all changes made to this operational hours group.",
    },
    btn1Text:{
        type: String,
    },
    btn2Text:{
        type: String,
        required: true,
    }
  },
  methods: {
    closeDialog() {
      this.$emit("update:dialog", false);
    },
    confirmAction() {
      this.$emit("confirm");
      this.closeDialog();
    },
  },
};
</script>

<style scoped>
.card_container {
  border-radius: 8px;
}
/* Add any additional styles here */
.headline {
  background-color: rgba(255, 181, 0, 1);
  color: var(--black-087, rgba(0, 0, 0, 0.87));
  font-family: Graphik !important;
  font-size: 20px !important;
  font-style: normal !important;
  font-weight: 600 !important;
  line-height: 32px !important;
  letter-spacing: 0.25px !important;
  padding: 16px !important;
}

.card-text {
  padding: 20px 16px 16px 16px !important;
  color: var(--black-087, rgba(0, 0, 0, 0.87)) !important;
  font-family: Graphik !important;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 400 !important;
  line-height: 22px !important;
  letter-spacing: 0.1px !important;
}

.left-btn {
  color: #7a6855 !important;
  border-radius: 4px;
  text-align: center !important;
  font-family: Graphik !important;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: 36px !important;
  letter-spacing: 1.25px !important;
  text-transform: uppercase !important;
}
.right-btn {
  color: var(--black-087, rgba(0, 0, 0, 0.87));
  border-radius: 4px;
  background: var(--grey-lighten-4, #f5f5f5);
  text-align: center !important;
  font-family: Graphik !important;
  font-size: 14px !important;
  font-style: normal !important;
  font-weight: 500 !important;
  line-height: 36px !important;
  letter-spacing: 1.25px !important;
  text-transform: uppercase !important;
}
</style>
